import React from 'react'
import { Link } from 'react-router-dom'



function Contact() {
    return (
        <div>





            <section class="Material-contact-section section-padding section-dark ">
                <div class="container bg-danger" id='bcc'>
                    <div class="row">
                        {/* <!-- Section Titile --> */}
                        <div class="col-md-12 wow animated fadeInLeft" data-wow-delay=".2s">
                            <h1 class="section-title">Love to Hear From You</h1>
                        </div>
                    </div>
                    <div class="row">
                        {/* <!-- Section Titile --> */}
                        <div class="col-md-6 mt-3 contact-widget-section2 wow animated fadeInLeft" data-wow-delay=".2s">
                            <p id='i'>Heyy guy's my name is Tinku Kumar Sahni , basically i from Shubhankar pur Darbhanga in BIHAR , my job profeesion is ,I am well trained <span>Denter/Pianter</span> of cars , curreentlly i am working in TATA MOTORS in Darbhnaga , Have any work from my side Free to Contant me </p>

                            <div class="find-widget">
                                Company where to work:  <Link  id='m' to="https://commercial-vehicles.buytrucknbus.tatamotors.com/location/bihar/darbhanga">TATA MOTORS</Link>
                            </div>
                            <div class="find-widget">
                                Address: <a  id='m' href="#">Shubhankar pur Darbhnaga </a>
                            </div>
                            <div class="find-widget">
                                Phone:  <a  id='m' href="#">990104038</a>
                            </div>

                            <div class="find-widget">
                                FaceBook:  <Link  id='m' to="https://www.facebook.com/profile.php?id=100006189343267">go to facebook</Link>
                            </div>

                            <div class="find-widget">
                                Instagram:  <Link  id='m' to="https://www.instagram.com/tinkuk634/">go to Intagram</Link>
                            </div>

                            <div class="find-widget">
                                Program: <a id='m' href="#">Mon to Sat: 09:30 AM - 10.30 PM</a>
                            </div>
                        </div>
                        {/* <!-- contact form --> */}
                        <div id='cont' class="col-md-6 wow animated fadeInRight" data-wow-delay=".2s">
                            <form class="shake" role="form" method="post" id="contactForm" name="contact-form" data-toggle="validator">
                                {/* <!-- Name --> */}
                                <div class="form-group label-floating">
                                    <label class="control-label" for="name">Name</label>
                                    <input class="form-control" id="name" type="text" name="name" required data-error="Please enter your name" />
                                    <div class="help-block with-errors"></div>
                                </div>
                                {/* <!-- email --> */}
                                <div class="form-group label-floating">
                                    <label class="control-label" for="email">Email</label>
                                    <input class="form-control" id="email" type="email" name="email" required data-error="Please enter your Email" />
                                    <div class="help-block with-errors"></div>
                                </div>
                                {/* <!-- Subject --> */}
                                <div class="form-group label-floating">
                                    <label class="control-label">Subject</label>
                                    <input class="form-control" id="msg_subject" type="text" name="subject" required data-error="Please enter your message subject" />
                                    <div class="help-block with-errors"></div>
                                </div>
                                {/* <!-- Message --> */}
                                <div class="form-group label-floating">
                                    <label for="message" class="control-label">Message</label>
                                    <textarea class="form-control" rows="3" id="message" name="message" required data-error="Write your message"></textarea>
                                    <div class="help-block with-errors"></div>
                                </div>
                                {/* <!-- Form Submit --> */}
                                <div class="form-submit mt-3">
                                    <button class="btn btn-common bg-warning" type="submit" id="form-submit"><i class="material-icons mdi mdi-message-outline"></i> Send Message</button>
                                    <div id="msgSubmit" class="h3 text-center hidden"></div>
                                    <div class="clearfix"></div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>







        </div>
    )
}

export default Contact
